module.exports = __webpack_public_path__ + "img/hudong.559cae43.png";